// Enhanced mock data with complete podcast-course linkages and new fields
export const courses = [
  {
    id: 101,
    title: "Introduction to AI and Machine Learning",
    description: "Learn the fundamentals of artificial intelligence and machine learning concepts, algorithms, and real-world applications.",
    skillLevel: "Beginner",
    duration: "6 hours",
    price: "Free",
    tier: "free",
    category: "Technology & AI",
    topics: ["AI/ML", "Programming", "Data Science"],
    rating: 4.8,
    students: 12500,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1011,
        title: "What is Artificial Intelligence?",
        lessons: [
          { id: 10111, title: "Introduction to AI", duration: "15 min" },
          { id: 10112, title: "History of AI", duration: "20 min" },
          { id: 10113, title: "AI Applications", duration: "25 min" }
        ]
      },
      {
        id: 1012,
        title: "Machine Learning Basics",
        lessons: [
          { id: 10121, title: "Supervised Learning", duration: "30 min" },
          { id: 10122, title: "Unsupervised Learning", duration: "25 min" },
          { id: 10123, title: "Reinforcement Learning", duration: "20 min" }
        ]
      }
    ],
    objectives: [
      "Understand core AI concepts and terminology",
      "Differentiate between AI, ML, and Deep Learning",
      "Identify real-world AI applications",
      "Set up basic ML development environment"
    ]
  },
  {
    id: 102,
    title: "Advanced Neural Networks",
    description: "Deep dive into neural network architectures, training techniques, and optimization methods for complex AI systems.",
    skillLevel: "Advanced",
    duration: "12 hours",
    price: "Saints Pro",
    tier: "scholarship",
    category: "Technology & AI",
    topics: ["AI/ML", "Neural Networks", "Deep Learning"],
    rating: 4.9,
    students: 8500,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1021,
        title: "Deep Learning Fundamentals",
        lessons: [
          { id: 10211, title: "Neural Network Architectures", duration: "30 min" },
          { id: 10212, title: "Backpropagation", duration: "35 min" },
          { id: 10213, title: "Activation Functions", duration: "25 min" }
        ]
      }
    ],
    objectives: [
      "Design and implement complex neural networks",
      "Optimize model performance and accuracy",
      "Apply advanced training techniques",
      "Troubleshoot common neural network issues"
    ]
  },
  {
    id: 103,
    title: "Web Development with React",
    description: "Build modern web applications using React, hooks, context API, and popular ecosystem libraries.",
    skillLevel: "Intermediate",
    duration: "8 hours",
    price: "Saints Plus",
    tier: "premium",
    category: "Technology & AI",
    topics: ["Web Development", "Programming", "Frontend"],
    rating: 4.7,
    students: 15600,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1031,
        title: "React Fundamentals",
        lessons: [
          { id: 10311, title: "Components and JSX", duration: "20 min" },
          { id: 10312, title: "Props and State", duration: "25 min" },
          { id: 10313, title: "Event Handling", duration: "15 min" }
        ]
      }
    ],
    objectives: [
      "Build reusable React components",
      "Manage application state effectively",
      "Integrate with APIs and backend services",
      "Deploy React applications to production"
    ]
  },
  {
    id: 104,
    title: "Startup Entrepreneurship 101",
    description: "Learn how to validate business ideas, build MVPs, and launch successful tech startups from scratch.",
    skillLevel: "Beginner",
    duration: "5 hours",
    price: "Free",
    tier: "free",
    category: "Business & Entrepreneurship",
    topics: ["Startups", "Marketing", "Leadership"],
    rating: 4.6,
    students: 9200,
    hasCertificate: false,
    image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1041,
        title: "Idea Validation",
        lessons: [
          { id: 10411, title: "Market Research", duration: "20 min" },
          { id: 10412, title: "Customer Discovery", duration: "25 min" },
          { id: 10413, title: "MVP Development", duration: "30 min" }
        ]
      }
    ],
    objectives: [
      "Validate business ideas effectively",
      "Create minimum viable products",
      "Develop go-to-market strategies",
      "Understand startup funding options"
    ]
  },
  {
    id: 105,
    title: "Digital Marketing Mastery",
    description: "Comprehensive guide to digital marketing strategies, SEO, social media, and conversion optimization.",
    skillLevel: "Intermediate",
    duration: "7 hours",
    price: "Saints Plus",
    tier: "premium",
    category: "Business & Entrepreneurship",
    topics: ["Marketing", "Strategy", "Sales"],
    rating: 4.5,
    students: 11300,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1051,
        title: "SEO Fundamentals",
        lessons: [
          { id: 10511, title: "Keyword Research", duration: "25 min" },
          { id: 10512, title: "On-Page SEO", duration: "30 min" },
          { id: 10513, title: "Link Building", duration: "20 min" }
        ]
      }
    ],
    objectives: [
      "Develop comprehensive marketing strategies",
      "Optimize websites for search engines",
      "Create engaging social media campaigns",
      "Analyze marketing performance metrics"
    ]
  },
  {
    id: 106,
    title: "UI/UX Design Principles",
    description: "Master user interface and experience design principles, prototyping, and user testing methodologies.",
    skillLevel: "Beginner",
    duration: "6 hours",
    price: "Free",
    tier: "free",
    category: "Creative Arts",
    topics: ["Design", "User Experience", "Prototyping"],
    rating: 4.7,
    students: 8700,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1061,
        title: "Design Thinking",
        lessons: [
          { id: 10611, title: "User Research", duration: "20 min" },
          { id: 10612, title: "Wireframing", duration: "25 min" },
          { id: 10613, title: "Prototyping", duration: "30 min" }
        ]
      }
    ],
    objectives: [
      "Apply design thinking methodologies",
      "Create effective user interfaces",
      "Conduct user research and testing",
      "Prototype and iterate designs"
    ]
  },
  {
    id: 107,
    title: "Music Production Fundamentals",
    description: "Learn music theory, digital audio workstations, mixing, and mastering for professional music production.",
    skillLevel: "Intermediate",
    duration: "9 hours",
    price: "Saints Pro",
    tier: "scholarship",
    category: "Creative Arts",
    topics: ["Music Production", "Audio Engineering", "Creative"],
    rating: 4.8,
    students: 5400,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1571974599782-87624638275f?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1071,
        title: "DAW Basics",
        lessons: [
          { id: 10711, title: "Setting Up Your Studio", duration: "25 min" },
          { id: 10712, title: "MIDI and Audio", duration: "30 min" },
          { id: 10713, title: "Basic Mixing", duration: "35 min" }
        ]
      }
    ],
    objectives: [
      "Navigate digital audio workstations",
      "Understand music theory fundamentals",
      "Mix and master audio tracks",
      "Produce professional-quality music"
    ]
  },
  {
    id: 108,
    title: "Productivity and Time Management",
    description: "Build effective productivity systems, manage time efficiently, and achieve your personal and professional goals.",
    skillLevel: "Beginner",
    duration: "4 hours",
    price: "Free",
    tier: "free",
    category: "Personal Development",
    topics: ["Productivity", "Time Management", "Habits"],
    rating: 4.6,
    students: 12800,
    hasCertificate: false,
    image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1081,
        title: "Productivity Systems",
        lessons: [
          { id: 10811, title: "Goal Setting", duration: "20 min" },
          { id: 10812, title: "Task Management", duration: "25 min" },
          { id: 10813, title: "Time Blocking", duration: "15 min" }
        ]
      }
    ],
    objectives: [
      "Implement effective productivity systems",
      "Manage time and priorities efficiently",
      "Build sustainable habits",
      "Achieve personal and professional goals"
    ]
  },
  {
    id: 109,
    title: "Space Exploration Technologies",
    description: "Explore the latest advancements in space technology, satellite systems, and future space missions.",
    skillLevel: "Intermediate",
    duration: "7 hours",
    price: "Saints Plus",
    tier: "premium",
    category: "Science & Innovation",
    topics: ["Space", "Engineering", "Innovation"],
    rating: 4.9,
    students: 6800,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1091,
        title: "Rocket Science Basics",
        lessons: [
          { id: 10911, title: "Orbital Mechanics", duration: "30 min" },
          { id: 10912, title: "Propulsion Systems", duration: "35 min" },
          { id: 10913, title: "Satellite Technology", duration: "25 min" }
        ]
      }
    ],
    objectives: [
      "Understand orbital mechanics principles",
      "Learn about propulsion technologies",
      "Explore satellite systems and applications",
      "Discuss future space exploration missions"
    ]
  },
  {
    id: 110,
    title: "Nutrition Science for Health",
    description: "Evidence-based nutrition principles, meal planning, and dietary strategies for optimal health and wellness.",
    skillLevel: "Beginner",
    duration: "5 hours",
    price: "Free",
    tier: "free",
    category: "Health & Wellness",
    topics: ["Nutrition", "Health", "Wellness"],
    rating: 4.7,
    students: 9500,
    hasCertificate: true,
    image: "https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=400&h=250&fit=crop",
    modules: [
      {
        id: 1101,
        title: "Nutrition Fundamentals",
        lessons: [
          { id: 11011, title: "Macronutrients", duration: "25 min" },
          { id: 11012, title: "Micronutrients", duration: "20 min" },
          { id: 11013, title: "Meal Planning", duration: "30 min" }
        ]
      }
    ],
    objectives: [
      "Understand basic nutrition principles",
      "Create balanced meal plans",
      "Identify nutritional needs for different goals",
      "Apply evidence-based dietary strategies"
    ]
  }
]

export const podcasts = [
  // Your original real podcasts
  {
    id: 201,
    title: "Digital Marketing Mastery: Strategies That Actually Work",
    summary: "A practical framework for modern digital marketing success. Learn to integrate data-driven tactics across key channels—from SEO and content to social media and email—to build a powerful online presence that delivers tangible business outcomes.",
    topic: "Business & Entrepreneurship",
    duration: "12:51",
    publishDate: "2025-11-20",
    relatedCourseId: 105,
    tier: "plus",
    episodeType: "Educational",
    topics: ["Marketing", "Strategy", "Business"],
    listens: 9800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    audioUrl: "/audio/podcasts/digital-marketing-mastery.mp3"
  },
  {
    id: 202,
    title: "Web Development in 2025: Modern Frameworks & Best Practices",
    summary: "Future-proof your skills and build faster, smarter applications. We explore the evolving ecosystem of modern frameworks, cutting-edge tools, and architectural patterns that will define web development in 2025 and beyond.",
    topic: "Technology & AI",
    duration: "16:12",
    publishDate: "2025-11-20",
    relatedCourseId: 103,
    tier: "plus",
    episodeType: "Tutorial",
    topics: ["Web Development", "React", "Programming"],
    listens: 11200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2030&q=80",
    audioUrl: "/audio/podcasts/web-development-2026.mp3"
  },
  {
    id: 203,
    title: "Neural Networks Demystified: Building Intelligent Systems",
    summary: "Ever wondered how AI truly learns? Go from theory to practice as we break down neural networks into understandable concepts. You'll learn how to build the foundational blocks that power everything from voice assistants to self-driving cars.",
    topic: "Technology & AI",
    duration: "16:15",
    publishDate: "2025-11-20",
    relatedCourseId: 102,
    tier: "pro",
    episodeType: "Deep Dive",
    topics: ["AI/ML", "Neural Networks", "Programming"],
    listens: 6700,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    audioUrl: "/audio/podcasts/neural-networks-advanced.mp3"
  },
  {
    id: 204,
    title: "AI Revolution: From Basics to Breakthroughs",
    summary: "Witness the evolution of intelligence itself. This journey starts with the core principles of AI and accelerates into the groundbreaking advancements—from generative models to artificial general intelligence—that are redefining every aspect of our world.",
    topic: "Technology & AI",
    duration: "16:12",
    publishDate: "2025-11-20",
    relatedCourseId: 101,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["AI/ML", "Technology", "Innovation"],
    listens: 8900,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    audioUrl: "/audio/podcasts/ai-revolution.mp3"
  },
  {
    id: 205,
    title: "Space Tech Innovations",
    summary: "Witness the new space age. From reusable rockets and lunar bases to next-gen satellite megaconstellations, discover the breakthroughs redefining humanity's future in the cosmos and its impact on Earth.",
    topic: "Science & Innovation",
    duration: "14:33",
    publishDate: "2025-11-20",
    relatedCourseId: null,
    tier: "plus",
    episodeType: "Educational",
    topics: ["Space", "Technology", "Innovation"],
    listens: 5800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1517976547714-720226b864c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    audioUrl: "/audio/podcasts/space-tech.mp3"
  },
 {
    id: 206,
    title: "Digital Marketing ROI Strategies",
    summary: "A data-driven playbook for marketing efficiency. Master the techniques of campaign tracking, performance analysis, and budget optimization to ensure your digital marketing efforts directly contribute to bottom-line results.",
    topic: "Business & Entrepreneurship",
    duration: "13:55",
    publishDate: "2025-11-20",
    relatedCourseId: 105,
    tier: "plus",
    episodeType: "Educational",
    topics: ["Marketing", "ROI", "Business Strategy"],
    listens: 6700,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/marketing-roi.mp3"
  },
  {
    id: 207,
    title: "The Future of AI in Healthcare",
    summary: "Exploring how artificial intelligence is revolutionizing medical diagnosis, treatment, and patient care systems.",
    topic: "Technology & AI",
    duration: "47:40",
    publishDate: "2025-12-05",
    relatedCourseId: 101,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["AI/ML", "Healthcare", "Technology"],
    listens: 12500,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/ai-healthcare.mp3"
  },
{
  id: 208,
  title: "The Secret Math Behind High-Growth Startups",
  summary: "What patterns do breakout companies share that others miss? We analyzed 500+ startup post-mortems, investor reports, and IPO filings to uncover the hidden algorithms of explosive growth. Discover the precise metrics that separate market leaders from forgotten ventures.",
  topic: "Business & Entrepreneurship",
  duration: "39:18",
  publishDate: "2025-02-25",
  relatedCourseId: 104,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Startups", "Growth Hacking", "Data Analysis", "Success Patterns"],
  listens: 15600,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/secret-math-high-growth-startups.mp3"
},
{
  id: 209,
  title: "Hacking Your Brain's Creativity Code",
  summary: "What if you could trigger creative breakthroughs on demand? We explore groundbreaking neuroscience research revealing how dopamine, flow states, and neural networks collaborate during creative work. Learn science-backed techniques to bypass creative blocks permanently.",
  topic: "Creative Arts",
  duration: "13:31",
  publishDate: "2025-01-08",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Educational",
  topics: ["Neuroscience", "Creativity", "Brain Hacking", "Flow States"],
  listens: 7600,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/hacking-creativity-code.mp3"
},
{
    id: 210,
    title: "React Architecture Patterns for Scalable Apps",
    summary: "Advanced React patterns and architectural decisions for building large-scale, maintainable applications.",
    topic: "Technology & AI",
    duration: "14:31",
    publishDate: "2025-12-18",
    relatedCourseId: 103,
    tier: "plus",
    episodeType: "Tutorial",
    topics: ["Web Development", "React", "Programming"],
    listens: 11200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/react-architecture.mp3"
  },
  {
  id: 211,
  title: "The Digital Alchemy of Hit Records",
  summary: "How do modern producers weave magic from ones and zeros? Discover the hidden technical architectures behind songs that dominate global playlists.",
  topic: "Creative Arts",
  duration: "13:11",
  publishDate: "2025-12-05",
  relatedCourseId: 107,
  tier: "pro",
  episodeType: "Tutorial",
  topics: ["Music Production", "Audio Engineering", "Hit Making", "Digital Alchemy"],
  listens: 4200,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1571974599782-87624638275f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-alchemy-hit-records.mp3"
},
  {
    id: 212,
    title: "Nutrition Science: Evidence-Based Approaches",
    summary: "Recent research findings in nutrition science and their practical applications for daily health and wellness.",
    topic: "Health & Wellness",
    duration: "15:01",
    publishDate: "2025-10-01",
    relatedCourseId: 110,
    tier: "free",
    episodeType: "Educational",
    topics: ["Nutrition", "Health", "Wellness"],
    listens: 9300,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1490818387583-1baba5e638af?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/nutrition-science.mp3"
  },
  {
    id: 213,
    title: "Productivity Systems for Remote Work",
    summary: "Evidence-based productivity methods and tools that help you achieve more with less stress in remote environments.",
    topic: "Personal Development",
    duration: "16:29",
    publishDate: "2025-11-28",
    relatedCourseId: 108,
    tier: "free",
    episodeType: "Tutorial",
    topics: ["Productivity", "Time Management", "Habits"],
    listens: 8100,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/productivity-systems.mp3"
  },
  {
    id: 214,
  title: "Why Movie Theater Popcorn Smells So Good (It's Engineered)",
  summary: "The science of scent marketing in cinemas. How specific popcorn formulas, butter-like chemicals, and ventilation systems create that irresistible smell that makes you buy overpriced snacks.",
  topic: "Creative Arts",
  duration: "12:02",
  publishDate: "2025-12-15",
  tier: "free",
  episodeType: "Educational",
  topics: ["Marketing", "Food Science", "Movies"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1489599809505-fc6acc43c69f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/movie-popcorn-science.mp3"
  },
  {
    id: 215,
    title: "Sustainable Business Practices",
    summary: "Exploring how businesses can implement sustainable practices while maintaining profitability and growth.",
    topic: "Business & Entrepreneurship",
    duration: "10:54",
    publishDate: "2025-11-28",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Critique",
    topics: ["Sustainability", "Business", "Entrepreneurship"],
    listens: 5400,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/sustainable-business.mp3"
  },

  // NEW PODCASTS - Technology & AI
  {
    id: 216,
    title: "The AI Arms Race: Yearly Breakdown of Tech Giants' Moves",
    summary: "Dive deep into the year's most explosive AI developments as tech giants battle for supremacy. We analyze OpenAI's GPT-5 breakthroughs, Google's Gemini ecosystem, Anthropic's constitutional AI approach, and the rising open-source rebellion. Discover who's leading the race, which strategies are working, and what these corporate battles mean for the future of artificial intelligence.",
    topic: "Technology & AI",
    duration: "13:33",
    publishDate: "2025-11-21",
    relatedCourseId: 101,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["AI/ML", "Technology", "Innovation"],
    listens: 8900,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/ai-arms-race.mp3"
  },
  {
    id: 217,
    title: "AI Ethics & Bias: Who's Responsible When AI Fails?",
    summary: "Investigating the datasets and human choices behind AI algorithms and who bears responsibility for discriminatory decisions.",
    topic: "Technology & AI",
    duration: "16:57",
    publishDate: "2025-11-28",
    relatedCourseId: 101,
    tier: "free",
    episodeType: "Debate",
    topics: ["AI/ML", "Ethics", "Technology"],
    listens: 7600,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/ai-ethics-bias.mp3"
  },
  {
    id: 218,
    title: "The Future of Search: AI Chatbots vs Traditional SEO",
    summary: "With AI chatbots providing direct answers, what happens to Google, SEO, and the fundamental business of the internet?",
    topic: "Technology & AI",
    duration: "31:14",
    publishDate: "2025-03-08",
    relatedCourseId: 103,
    tier: "plus",
    episodeType: "Deep Dive",
    topics: ["AI/ML", "Search", "Business"],
    listens: 6800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/future-of-search.mp3"
  },
  {
    id: 219,
    title: "Synthetic Media & Deepfakes: The New Reality",
    summary: "Exploring the technology behind creating realistic fake video/audio and its implications for entertainment and security.",
    topic: "Technology & AI",
    duration: "14:25",
    publishDate: "2025-03-05",
    relatedCourseId: 101,
    tier: "free",
    episodeType: "Educational",
    topics: ["AI/ML", "Media", "Security"],
    listens: 9200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1536240478700-b869070f9279?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/synthetic-media.mp3"
  },
  {
    id: 220,
    title: "The Open-Source AI Revolution",
    summary: "Exploring the powerful AI models being developed for free by communities and how they challenge big tech dominance.",
    topic: "Technology & AI",
    duration: "39:20",
    publishDate: "Coming soon",
    relatedCourseId: 102,
    tier: "pro",
    episodeType: "Deep Dive",
    topics: ["AI/ML", "Open Source", "Innovation"],
    listens: 5400,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=250&fit=crop",
    audioUrl: "/audio/open-source-ai.mp3"
  },
  // {
  //   id: 221, //repeat topic
  //   title: "AI in Healthcare: From Diagnosis to Drug Discovery",
  //   summary: "How machine learning is revolutionizing medicine, from disease diagnosis to discovering new pharmaceutical treatments.",
  //   topic: "Technology & AI",
  //   duration: "43:10",
  //   publishDate: "2024-02-28",
  //   relatedCourseId: 101,
  //   tier: "free",
  //   episodeType: "Educational",
  //   topics: ["AI/ML", "Healthcare", "Medicine"],
  //   listens: 7800,
  //   isDownloadable: false,
  //   image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=400&h=250&fit=crop",
  //   audioUrl: "/audio/ai-healthcare-advances.mp3"
  // },
  {
    id: 222,
    title: "The Spatial Computing Era: Beyond VR vs AR",
    summary: "Exploring Apple's Vision Pro and the new era of computing that seamlessly blends digital and physical worlds.",
    topic: "Technology & AI",
    duration: "33:20",
    publishDate: "2025-02-25",
    relatedCourseId: 103,
    tier: "plus",
    episodeType: "Deep Dive",
    topics: ["VR/AR", "Technology", "Innovation"],
    listens: 6100,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1592478411213-6153e4ebc696?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/spatial-computing.mp3"
  },
  {
    id: 223,
    title: "Quantum Computing's 'Noisy' Present",
    summary: "Explaining the real, tangible advancements in quantum computing, cutting through the hype to explain what's actually happening in labs.",
    topic: "Technology & AI",
    duration: "15:37",
    publishDate: "2025-02-22",
    relatedCourseId: 102,
    tier: "pro",
    episodeType: "Educational",
    topics: ["Quantum Computing", "Science", "Technology"],
    listens: 4900,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/quantum-computing.mp3"
  },

  // NEW PODCASTS - Business & Entrepreneurship
  {
    id: 224,
    title: "The Creator Economy Shake-Up",
    summary: "From algorithm earthquakes to monetization meltdowns, the creator economy is being completely rewritten. We break down the seismic shifts across TikTok, YouTube, Instagram, and emerging platforms. Discover which content strategies are winning in 2024, how to diversify revenue beyond platform dependence, and what the rise of AI means for the future of creative work.",
    topic: "Business & Entrepreneurship",
    duration: "13:25",
    publishDate: "2025-11-21",
    relatedCourseId: 105,
    tier: "plus",
    episodeType: "Deep Dive",
    topics: ["Creator Economy", "Social Media", "Business"],
    listens: 8500,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/creator-economy.mp3"
  },
  {
    id: 225,
    title: "The 'De-Influencing' Trend Analysis",
    summary: "Analyzing the social media trend of telling people what not to buy. Is it genuine consumer advice or just a new form of influencing?",
    topic: "Business & Entrepreneurship",
    duration: "11:44",
    publishDate: "2025-11-28",
    relatedCourseId: 105,
    tier: "plus",
    episodeType: "Critique",
    topics: ["Marketing", "Social Media", "Consumer Behavior"],
    listens: 7200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/de-influencing.mp3"
  },
  {
    id: 226, //probably a repeat as well
    title: "Geopolitics of Tech: TikTok Bans & Semiconductor Wars",
    summary: "The ongoing TikTok bans, semiconductor wars between the US and China, and the global race for AI supremacy.",
    topic: "Business & Entrepreneurship",
    duration: "47:15",
    publishDate: "Coming soon",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Debate",
    topics: ["Geopolitics", "Technology", "Business"],
    listens: 9300,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=250&fit=crop",
    audioUrl: "/audio/geopolitics-tech.mp3"
  },
  {
    id: 227,
    title: "The 'Lazy Girl Job' & Workplace Trends",
    summary: "Exploring this viral term and what it says about Gen Z's approach to work-life balance, quiet quitting, and career expectations.",
    topic: "Business & Entrepreneurship",
    duration: "14:14",
    publishDate: "2025-11-28",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Educational",
    topics: ["Workplace", "Gen Z", "Career"],
    listens: 6800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/lazy-girl-job.mp3"
  },
  {
    id: 228,
    title: "The 'Pink-Collar' Recession Analysis",
    summary: "Analyzing why female-dominated industries were hit differently post-pandemic and what that means for the future of work.",
    topic: "Business & Entrepreneurship",
    duration: "39:15",
    publishDate: "2025-02-29",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["Workplace", "Gender", "Economics"],
    listens: 5900,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1551836026-d5c8e2c2e99c?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/pink-collar-recession.mp3"
  },
  {
    id: 229,
    title: "Building a 'Million-Dollar, One-Person' Business",
    summary: "Case studies on solopreneurs using automation, AI, and outsourcing to build highly profitable companies with no employees.",
    topic: "Business & Entrepreneurship",
    duration: "31:16",
    publishDate: "2025-11-28",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Educational",
    topics: ["Entrepreneurship", "Business", "Automation"],
    listens: 7700,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/one-person-business.mp3"
  },
  {
    id: 230,
    title: "The Collapse of Well-Funded Startups: A Post-Mortem",
    summary: "Examining the missteps, market conditions, and leadership flaws that led to the failure of heavily funded startups.",
    topic: "Business & Entrepreneurship",
    duration: "40:16",
    publishDate: "2025-02-23",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Deep dive",
    topics: ["Startups", "Business", "Failure Analysis"],
    listens: 8200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1563013541-7d3c6e9a5a34?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/startup-failures.mp3"
  },
  {
    id: 231,
    title: "The Rise of 'De-Amazonification'",
    summary: "How direct-to-consumer (D2C) brands are building communities and loyalty outside of massive online marketplaces.",
    topic: "Business & Entrepreneurship",
    duration: "10:43",
    publishDate: "2025-12-07",
    relatedCourseId: 105,
    tier: "plus",
    episodeType: "Critique",
    topics: ["E-commerce", "D2C", "Business Strategy"],
    listens: 7100,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1563013541-7d3c6e9a5a34?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/de-amazonification.mp3"
  },
  {
    id: 232,
    title: "ESG Investing: Virtue or Value?",
    summary: "A critical look at Environmental, Social, and Governance investing—is it driving real change or just greenwashing?",
    topic: "Business & Entrepreneurship",
    duration: "17:55",
    publishDate: "2025-02-17",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Debate",
    topics: ["Investing", "Sustainability", "Business Ethics"],
    listens: 6500,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/esg-investing.mp3"
  },
  {
    id: 233,
    title: "The Franchise Model Deep Dive",
    summary: "Is buying a franchise the safest path to entrepreneurship?",
    topic: "Business & Entrepreneurship",
    duration: "14:21",
    publishDate: "2025-12-14",
    relatedCourseId: 104,
    tier: "free",
    episodeType: "Educational",
    topics: ["Franchising", "Entrepreneurship", "Business"],
    listens: 5800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/franchise-model.mp3"
  },

  // NEW PODCASTS - Creative Arts
  {
    id: 234,
    title: "The Anatomy of a Viral Hit",
    summary: "Deconstructing a recent viral song, TikTok trend, or meme to understand the cultural and algorithmic ingredients that made it explode.",
    topic: "Creative Arts",
    duration: "11:09",
    publishDate: "2025-11-28",
    relatedCourseId: 106,
    tier: "free",
    episodeType: "Critique",
    topics: ["Viral Content", "Social Media", "Culture"],
    listens: 9400,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/viral-hit-anatomy.mp3"
  },
  {
  id: 235, //maybe a repeat
  title: "When AI Becomes Your Creative Co-Pilot",
  summary: "What happens when artists team up with artificial intelligence? Analyzing thousands of AI-assisted artworks, novels, and compositions to uncover surprising patterns in human-machine collaboration. Discover which creative tasks AI excels at—and where it spectacularly fails.",
  topic: "Creative Arts",
  duration: "13:20",
  publishDate: "2025-03-09",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Educational",
  topics: ["AI Collaboration", "Creative AI", "Art & Technology", "Co-Creation"],
  listens: 8300,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/ai-creative-copilot.mp3"
},
  {
    id: 236,
    title: "The 'Uncanny Valley' in Animation",
    summary: "Exploring why some animated films feel creepy and others don't, and how the line is constantly shifting.",
    topic: "Creative Arts",
    duration: "11:41",
    publishDate: "2025-03-06",
    relatedCourseId: 106,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["Animation", "Psychology", "Film"],
    listens: 6700,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1489599809505-fc6acc43c69f?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/uncanny-valley.mp3"
  },
  {
  id: 237,
  title: "Broadway's High-Stakes Stage Magic",
  summary: "How does a Broadway show become a financial powerhouse? We analyze production budgets, ticket pricing algorithms, and marketing blueprints that transform empty stages into cultural phenomena. The surprising economics behind why some shows run for decades.",
  topic: "Creative Arts",
  duration: "14:56",
  publishDate: "2025-03-03",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Broadway Economics", "Production Magic", "Cultural Phenomena", "Entertainment Finance"],
  listens: 5200,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1503095396540-38b85ecb18b4?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/broadway-high-stakes-magic.mp3"
},
  {
    id: 238,
    title: "The Resurgence of Analog",
    summary: "Why are vinyl records, film cameras, and board games having a moment in a digital world?",
    topic: "Creative Arts",
    duration: "33:45",
    publishDate: "Coming soon",
    relatedCourseId: 106,
    tier: "free",
    episodeType: "Educational",
    topics: ["Analog", "Culture", "Technology"],
    listens: 7800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1571974599782-87624638275f?w=400&h=250&fit=crop",
    audioUrl: "/audio/analog-resurgence.mp3"
  },
 {
  id: 239,
  title: "The Art of Creative Genealogy",
  summary: "Every great idea has ancestors. We trace the DNA of modern masterpieces back through history using bibliographic networks and influence mapping. Discover how today's innovators consciously (and unconsciously) remix centuries of creative evolution.",
  topic: "Creative Arts",
  duration: "15:07",
  publishDate: "2025-12-25",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Educational",
  topics: ["Creative Lineage", "Influence Mapping", "Innovation Patterns", "Art History"],
  listens: 6900,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/creative-genealogy.mp3"
},

  // NEW PODCASTS - Personal Development
  {
    id: 240,
    title: "Digital Minimalism Challenge",
    summary: "Tired of being owned by your devices? We conducted an extreme digital minimalism experiment: no smartphones, no social media, no endless scrolling. Discover how eliminating digital clutter unlocked 12+ hours of productive time weekly, improved sleep quality, and restored deep focus. Get the step-by-step system to redesign your digital life for maximum impact and minimum distraction.",
    topic: "Personal Development",
    duration: "14:38",
    publishDate: "2025-11-21",
    relatedCourseId: 108,
    tier: "free",
    episodeType: "Tutorial",
    topics: ["Digital Minimalism", "Productivity", "Mental Health"],
    listens: 8500,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/digital-minimalism.mp3"
  },
  {
    id: 241,
    title: "The 'Soft Life' & Rejecting Hustle Culture",
    summary: "Exploring the movement, particularly among women of color, to prioritize ease, comfort, and joy over relentless ambition.",
    topic: "Personal Development",
    duration: "15:18",
    publishDate: "2025-11-28",
    relatedCourseId: 108,
    tier: "free",
    episodeType: "Debate",
    topics: ["Work-Life Balance", "Culture", "Wellness"],
    listens: 9200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1491841559745-e86082a0c94a?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/soft-life.mp3"
  },
  {
    id: 242,
    title: "Navigating a 'Platonic Breakup'",
    summary: "The real pain of losing a close friend, why it happens, and how to heal from friendship endings.",
    topic: "Personal Development",
    duration: "12:29",
    publishDate: "2024-03-05",
    relatedCourseId: 108,
    tier: "free",
    episodeType: "Educational",
    topics: ["Friendship", "Mental Health", "Relationships"],
    listens: 7700,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/platonic-breakup.mp3"
  },
  {
    id: 243,
    title: "The Science of Habit Stacking",
    summary: "Practical, neuroscience-backed advice for building good habits and breaking bad ones by 'stacking' them onto existing routines.",
    topic: "Personal Development",
    duration: "39:40",
    publishDate: "Coming soon",
    relatedCourseId: 108,
    tier: "free",
    episodeType: "Tutorial",
    topics: ["Habits", "Productivity", "Neuroscience"],
    listens: 8800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop",
    audioUrl: "/audio/habit-stacking.mp3"
  },
  {
    id: 244,
    title: "Financial Therapy: Money & Emotions",
    summary: "Exploring the emotional and psychological relationship we have with money, from shame and fear to empowerment.",
    topic: "Personal Development",
    duration: "13:56",
    publishDate: "2025-11-28",
    relatedCourseId: 108,
    tier: "free",
    episodeType: "Educational",
    topics: ["Finance", "Psychology", "Mental Health"],
    listens: 7100,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/financial-therapy.mp3"
  },
  {
  id: 245,
  title: "Redefining Success: The Metrics That Actually Matter",
  summary: "What if everything we measure about success is wrong? We examine data from happiness studies, life satisfaction surveys, and career longevity research to challenge conventional achievement metrics. Discover alternative frameworks for measuring a life well-lived.",
  topic: "Personal Development",
  duration: "47:35",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Success Metrics", "Life Design", "Happiness Research", "Purpose"],
  listens: 8300,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
  audioUrl: "/audio/redefining-success-metrics.mp3"
},

  // NEW PODCASTS - Science & Innovation
  {
    id: 246,
    title: "The mRNA Revolution Beyond Vaccines",
    summary: "How the mRNA technology from COVID vaccines is now being tested to fight cancer, HIV, and genetic diseases.",
    topic: "Science & Innovation",
    duration: "46:42",
    publishDate: "2025-11-28",
    relatedCourseId: 109,
    tier: "plus",
    episodeType: "Deep Dive",
    topics: ["mRNA", "Medicine", "Biotech"],
    listens: 6800,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/mrna-revolution.mp3"
  },
  {
    id: 247,
    title: "The Psychedelic Renaissance",
    summary: "The serious, scientific research into psilocybin, MDMA, and ketamine for treating depression, PTSD, and addiction.",
    topic: "Science & Innovation",
    duration: "36:17",
    publishDate: "2025-11-28",
    relatedCourseId: 109,
    tier: "plus",
    episodeType: "Deep Dive",
    topics: ["Psychedelics", "Mental Health", "Research"],
    listens: 5900,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/psychedelic-renaissance.mp3"
  },
  {
    id: 248,
    title: "The Secrets of the Gut-Brain Axis",
    summary: "Exploring the fascinating connection between our digestive system and our mental health.",
    topic: "Science & Innovation",
    duration: "38:30",
    publishDate: "Coming soon",
    relatedCourseId: 109,
    tier: "plus",
    episodeType: "Educational",
    topics: ["Neuroscience", "Health", "Biology"],
    listens: 7200,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop",
    audioUrl: "/audio/gut-brain-axis.mp3"
  },
  {
    id: 249,
    title: "The Mission to Mine Asteroids",
    summary: "Is asteroid mining science fiction, or a near-future reality? The companies, technologies, and legal frameworks.",
    topic: "Science & Innovation",
    duration: "43:45",
    publishDate: "Coming soon",
    relatedCourseId: 109,
    tier: "plus",
    episodeType: "Deep Dive",
    topics: ["Space", "Mining", "Technology"],
    listens: 5400,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=400&h=250&fit=crop",
    audioUrl: "/audio/asteroid-mining.mp3"
  },
  {
    id: 250,
    title: "The Carbon Capture Conundrum",
    summary: "Examining technologies designed to pull CO2 directly from the air—are they viable solutions or dangerous distractions?",
    topic: "Science & Innovation",
    duration: "40:20",
    publishDate: "Coming soon",
    relatedCourseId: 109,
    tier: "plus",
    episodeType: "Debate",
    topics: ["Climate", "Technology", "Environment"],
    listens: 6600,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1569163139394-de44cb2c8cb7?w=400&h=250&fit=crop",
    audioUrl: "/audio/carbon-capture.mp3"
  },
  {
    id: 251,
    title: "Lab-Grown Meat: Coming to a Grill Near You",
    summary: "The science, regulatory hurdles, and consumer acceptance of cultivated meat products.",
    topic: "Science & Innovation",
    duration: "16:11",
    publishDate: "2025-11-28",
    relatedCourseId: 109,
    tier: "plus",
    episodeType: "Educational",
    topics: ["Food Science", "Biotech", "Sustainability"],
    listens: 6100,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/lab-grown-meat.mp3"
  },

  // NEW PODCASTS - Health & Wellness
  {
    id: 252,
    title: "The New Weight Loss Drugs: Ozempic & Beyond",
    summary: "A balanced look at the science, societal impact, hype, and ethical questions surrounding GLP-1 agonists.",
    topic: "Health & Wellness",
    duration: "15:13",
    publishDate: "2025-11-28",
    relatedCourseId: 110,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["Weight Loss", "Medicine", "Health"],
    listens: 9500,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop",
    audioUrl: "/audio/podcasts/weight-loss-drugs.mp3"
  },
 {
  id: 253,
  title: "The Longevity Code of Blue Zones",
  summary: "What secrets do the world's longest-living communities hide in plain sight? Analyzing decades of epidemiological data, dietary patterns, and social structures from Okinawa, Sardinia, and other longevity hotspots. Practical lifestyle adaptations backed by hard science.",
  topic: "Health & Wellness",
  duration: "39:25",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Educational",
  topics: ["Longevity", "Blue Zones", "Health Science", "Lifestyle Design"],
  listens: 8200,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1491841559745-e86082a0c94a?w=400&h=250&fit=crop",
  audioUrl: "/audio/longevity-code-blue-zones.mp3"
},
{
  id: 254,
  title: "The Sober-Curious Science Experiment",
  summary: "What really happens to your brain, body, and social life when you ditch alcohol? We examine neuroscience studies, sleep research, and social psychology data on the sober-curious movement. The surprising cognitive and social benefits backed by clinical evidence.",
  topic: "Health & Wellness",
  duration: "35:40",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Educational",
  topics: ["Sobriety Science", "Cognitive Benefits", "Social Dynamics", "Health Optimization"],
  listens: 7800,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=400&h=250&fit=crop",
  audioUrl: "/audio/sober-curious-science.mp3"
},
  {
    id: 255,
    title: "'Body Doubling' for Neurodivergent Adults",
    summary: "Why does working alongside someone dramatically improve focus for people with ADHD? Exploring the science and applications.",
    topic: "Health & Wellness",
    duration: "33:50",
    publishDate: "Coming soon",
    relatedCourseId: 110,
    tier: "free",
    episodeType: "Educational",
    topics: ["ADHD", "Productivity", "Mental Health"],
    listens: 6900,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=250&fit=crop",
    audioUrl: "/audio/body-doubling.mp3"
  },
  {
    id: 256,
    title: "The Health Toll of Loneliness",
    summary: "Discussing the U.S. Surgeon General's warning on the epidemic of loneliness and its physical health consequences.",
    topic: "Health & Wellness",
    duration: "41:15",
    publishDate: "Coming soon",
    relatedCourseId: 110,
    tier: "free",
    episodeType: "Deep Dive",
    topics: ["Mental Health", "Loneliness", "Public Health"],
    listens: 8700,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop",
    audioUrl: "/audio/loneliness-health.mp3"
  },
  {
    id: 257,
    title: "Cold Plunge & Heat Exposure Science",
    summary: "Separating the trendy biohacking from the genuine physiological benefits of deliberate temperature stress.",
    topic: "Health & Wellness",
    duration: "36:30",
    publishDate: "Coming soon",
    relatedCourseId: 110,
    tier: "free",
    episodeType: "Educational",
    topics: ["Biohacking", "Health", "Wellness"],
    listens: 7400,
    isDownloadable: false,
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop",
    audioUrl: "/audio/temperature-therapy.mp3"
  },
  {
  id: 258,
  title: "AI OS: The Next Generation of Computing",
  summary: "Exploring how AI is evolving from standalone apps to becoming the operating system itself. We dissect Microsoft's Copilot+ PCs, Apple's on-device AI integration, and Google's AI-first vision. Discover how this shift will change how we interact with every device and what it means for developers and users alike.",
  topic: "Technology & AI",
  duration: "18:22",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["AI/ML", "Operating Systems", "Future Tech"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/ai-operating-system.mp3"
},
{
  id: 259,
  title: "The Dark AI Economy: Shadow AI in Corporations",
  summary: "A shocking investigation into how employees are secretly using unauthorized AI tools within Fortune 500 companies, creating massive security and compliance risks. Learn about the underground AI market, the tools slipping through IT's fingers, and what this means for corporate governance in the AI era.",
  topic: "Technology & AI",
  duration: "22:15",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["AI/ML", "Cybersecurity", "Corporate Governance"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/dark-ai-economy.mp3"
},
{
  id: 260,
  title: "The $10K/Month Newsletter: Creator Monetization Revolution",
  summary: "How niche newsletters are quietly generating more revenue than traditional media. We breakdown the playbooks of top earners in tech, finance, and lifestyle niches. Learn audience building, premium content strategies, and the unconventional monetization models turning email lists into cash machines.",
  topic: "Business & Entrepreneurship",
  duration: "17:45",
  publishDate: "Coming soon",
  relatedCourseId: 105,
  tier: "plus",
  episodeType: "Tutorial",
  topics: ["Newsletters", "Monetization", "Creator Economy"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/newsletter-millionaires.mp3"
},
{
  id: 261,
  title: "The 'Stealth' Recession: Hidden Economic Indicators",
  summary: "While headlines focus on stock markets, we uncover the subtle economic shifts most people are missing. From rising business insolvencies to shrinking profit margins in unexpected sectors, learn what the 'soft data' reveals about where the economy is truly headed and how to position yourself.",
  topic: "Business & Entrepreneurship",
  duration: "21:30",
  publishDate: "Coming soon",
  relatedCourseId: 104,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Economics", "Recession", "Business Strategy"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/stealth-recession.mp3"
},
{
  id: 262,
  title: "Quantum Biology: When Quantum Mechanics Meets Life",
  summary: "Groundbreaking research reveals quantum effects in photosynthesis, bird navigation, and even human consciousness. We explore how nature has been using quantum mechanics for billions of years and what this means for future technologies in medicine, computing, and energy.",
  topic: "Science & Innovation",
  duration: "24:10",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["Quantum Physics", "Biology", "Cutting Edge Science"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/quantum-biology.mp3"
},
{
  id: 263,
  title: "The Dopamine Economy: Why Everything Feels Less Satisfying",
  summary: "How social media, streaming, and modern technology have hijacked our brain's reward system. We explore the neuroscience behind why achievements feel less meaningful, entertainment feels less entertaining, and what practical steps you can take to reset your dopamine baseline for a more satisfying life.",
  topic: "Health & Wellness",
  duration: "19:20",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Educational",
  topics: ["Neuroscience", "Mental Health", "Digital Wellness"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/dopamine-economy.mp3"
},
{
  id: 264,
  title: "The Microplastics Crisis Inside Us",
  summary: "Scientists are finding microplastics in human blood, placentas, and brains. What does this mean for our health? We separate alarming headlines from actual science, explore potential health impacts, and discuss practical ways to reduce your exposure while waiting for global solutions.",
  topic: "Health & Wellness",
  duration: "16:45",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Environmental Health", "Microplastics", "Public Health"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1569163139394-de44cb2c8cb7?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/microplastics-crisis.mp3"
},
{
  id: 265,
  title: "The 4-Day Workweek Revolution: Data vs. Hype",
  summary: "We analyze real-world data from companies that switched to a 4-day workweek. Which industries saw productivity boosts? Where did it fail? Learn the implementation frameworks that actually work, the hidden costs nobody talks about, and whether this could become the new standard.",
  topic: "Personal Development",
  duration: "20:15",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "plus",
  episodeType: "Debate",
  topics: ["Workplace", "Productivity", "Work-Life Balance"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/4day-workweek.mp3"
},
{
  id: 266,
  title: "AI Copyright Wars: Who Owns Generated Art?",
  summary: "The legal battles reshaping creative industries. We analyze landmark cases where artists sue AI companies, discuss the 'style theft' debate, and explore new licensing models emerging. This isn't just about art—it's about the future of all creative work in the AI era.",
  topic: "Creative Arts",
  duration: "18:50",
  publishDate: "Coming soon",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Debate",
  topics: ["AI Art", "Copyright", "Legal"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/ai-copyright-wars.mp3"
},
{
  id: 267,
  title: "The Lost Technologies of Ancient Civilizations",
  summary: "From Roman concrete that strengthens over time to Damascus steel that modern metallurgy can't replicate. We explore ancient technologies that were lost to history and what they teach us about innovation, knowledge preservation, and the cyclical nature of progress.",
  topic: "History & Culture",
  duration: "23:30",
  publishDate: "Coming soon",
  relatedCourseId: null, // Would need corresponding course
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["History", "Technology", "Ancient Civilizations"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/lost-technologies.mp3"
},
{
  id: 268,
  title: "Internet Archaeology: Digging Up Web 1.0",
  summary: "What happened to GeoCities, MySpace, and the early internet's creative chaos? We explore digital preservation efforts, interview people running web archives, and discuss what we're losing as the internet becomes more corporate and homogeneous.",
  topic: "History & Culture",
  duration: "17:10",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "free",
  episodeType: "Educational",
  topics: ["Internet History", "Digital Preservation", "Culture"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/internet-archaeology.mp3"
},
{
  id: 269,
  title: "The Secret Lab in the Spare Bedroom",
  summary: "How are hobbyists building electronics setups that rival Silicon Valley R&D labs? We explore the underground world of home research facilities where breakthroughs happen after hours. Discover the hacker-grade equipment and genius workarounds turning basements into innovation hubs.",
  topic: "Skills & Hobbies",
  duration: "25:45",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "plus",
  episodeType: "Tutorial",
  topics: ["Home Labs", "Hardware Hacking", "Maker Revolution", "DIY Innovation"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/secret-spare-bedroom-lab.mp3"
},
{
  id: 270,
  title: "Why Internet Trends Live Fast and Die Young",
  summary: "What secret algorithm kills viral movements overnight? We decode the explosive lifecycle of internet-born genres—from vaporwave's birth to cottagecore's peak to sea shanty collapse. Discover why digital culture now evolves at light speed, and what that reveals about our collective attention span.",
  topic: "Creative Arts",
  duration: "14:25",
  publishDate: "Coming soon",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Critique",
  topics: ["Internet Culture", "Viral Patterns", "Attention Economy", "Digital Evolution"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/internet-trends-life-death.mp3"
},
{
  id: 271,
  title: "The Secret Language of Emoji Evolution",
  summary: "How did 🍆 become... that? Why does 🥺 mean puppy eyes? We explore the fascinating, unofficial evolution of emoji meanings across cultures and platforms. Plus: predictions for which new emojis will develop secret meanings next.",
  topic: "Creative Arts",
  duration: "12:45",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "free",
  episodeType: "Educational",
  topics: ["Emoji", "Digital Communication", "Culture"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1611605698323-b1e99cfd37ea?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/emoji-evolution.mp3"
},
{
  id: 272,
  title: "The Bagel vs. Donut Physics War",
  summary: "Which breakfast pastry has superior engineering? We analyze food science data, texture profiles, and consumer preference studies to settle the great carb debate once and for all. The surprising physics behind why each has cult-like followings.",
  topic: "Science & Innovation",
  duration: "16:30",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "plus",
  episodeType: "Educational",
  topics: ["Food Science", "Material Physics", "Consumer Psychology", "Culinary Engineering"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1551024506-0bccd828d307?w=400&h=250&fit=crop",
  audioUrl: "/audio/bagel-donut-physics-war.mp3"
},
{
  id: 273,
  title: "The Midnight Snack Engineering Challenge",
  summary: "What makes the perfect 3 AM snack? We analyze food chemistry, texture interaction data, and satisfaction metrics to reverse-engineer the ultimate late-night creation. Science-backed principles for maximum satisfaction with minimum mess.",
  topic: "Science & Innovation",
  duration: "15:20",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "plus",
  episodeType: "Tutorial",
  topics: ["Food Engineering", "Snack Science", "Flavor Chemistry", "Culinary Design"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=400&h=250&fit=crop",
  audioUrl: "/audio/midnight-snack-engineering.mp3"
},
{
  id: 274,
  title: "The Psychology of Video Game Satisfaction Sounds",
  summary: "Why does picking up a coin in Mario feel so good? We explore the auditory psychology behind game design—from the 'ding' of leveling up to the 'cha-ching' of loot. With sound designers and psychologists, we discover why these tiny audio cues are secretly controlling our dopamine.",
  topic: "Creative Arts",
  duration: "13:50",
  publishDate: "Coming soon",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Educational",
  topics: ["Gaming", "Psychology", "Sound Design"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/game-satisfaction-sounds.mp3"
},
{
  id: 275,
  title: "Speedrunning: The Mathematics of Breaking Games",
  summary: "How do players beat Super Mario 64 blindfolded? We analyze frame-perfect inputs, glitch exploitation algorithms, and game engine manipulation techniques. The computational thinking behind what looks like gaming wizardry.",
  topic: "Creative Arts",
  duration: "18:15",
  publishDate: "Coming soon",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Game Theory", "Computational Thinking", "Problem Solving", "Speedrun Science"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1534423861386-85a16f5d13fd?w=400&h=250&fit=crop",
  audioUrl: "/audio/speedrunning-mathematics.mp3"
},
{
  id: 276,
  title: "Why Does Time Feel Weird After 2020?",
  summary: "An informal investigation into our collective time perception disorder. Is it just us, or do months now blur together? Why does 2019 feel like yesterday and also ancient history? We talk to neuroscientists, philosophers, and regular people about our broken internal clocks.",
  topic: "Personal Development",
  duration: "14:10",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Debate",
  topics: ["Time Perception", "Psychology", "Modern Life"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1501139083538-0139583c060f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/weird-time-feeling.mp3"
},
{
  id: 277,
  title: "The Case of the Disappearing Socks",
  summary: "Where do socks actually vanish to? We crack the century-old mystery using textile forensics, washing machine autopsies, and quantum laundry theory (seriously). The shocking scientific truth behind one of life's greatest domestic puzzles.",
  topic: "Science & Innovation",
  duration: "11:55",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Educational",
  topics: ["Everyday Mysteries", "Forensic Science", "Textile Forensics", "Domestic Physics"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1586511925558-a4c6376c4e59?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/case-disappearing-socks.mp3"
},
{
  id: 278,
  title: "Abandoned Mall Tourism: The Ghost Towns of Consumerism",
  summary: "Exploring the strangely beautiful world of dead shopping malls. We visit locations across the country, talk to urban explorers, and examine what these decaying temples of 80s/90s consumerism tell us about retail, community, and architectural nostalgia.",
  topic: "History & Culture",
  duration: "19:30",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Urban Exploration", "Architecture", "Nostalgia"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/abandoned-malls.mp3"
},
{
  id: 279,
  title: "The World's Most Unusual Libraries",
  summary: "From libraries on donkeys in Colombia to bookshelves in phone booths in England. We explore the most creative, bizarre, and beautiful libraries around the world and interview the people who created them. Plus: how to start your own micro-library.",
  topic: "History & Culture",
  duration: "17:45",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "plus",
  episodeType: "Educational",
  topics: ["Libraries", "Travel", "Books"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/unusual-libraries.mp3"
},
{
  id: 280,
  title: "Slow Cooker Science: The Physics of Low-Temp Cooking",
  summary: "What culinary alchemy happens at 200°F? We analyze the chemistry of collagen breakdown, starch gelatinization, and protein denaturation in slow cooking. Discover which dishes transform beautifully over hours and which require precise temperature control that slow cookers can't provide.",
  topic: "Science & Innovation",
  duration: "15:40",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Educational",
  topics: ["Food Science", "Thermodynamics", "Cooking Chemistry", "Kitchen Physics"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/slow-cooker-science.mp3"
},
{
  id: 281,
  title: "The Rube Goldberg Morning: Why Over-Engineering Reveals Genius",
  summary: "What if waking up involved domino chains, pulley systems, and miniature catapults? We analyze how absurdly complex solutions expose hidden truths about efficiency. Discover why the most ridiculous machines teach us the most about elegant problem-solving.",
  topic: "Science & Innovation",
  duration: "16:20",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Tutorial",
  topics: ["Rube Goldberg", "Creative Engineering", "Problem Solving", "Mechanical Poetry"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/rube-goldberg-morning-genius.mp3"
},
{
  id: 282,
  title: "Crows: The Smartest Animals You're Underestimating",
  summary: "They use tools, recognize human faces, hold grudges, and even gift shiny objects to people they like. We explore the incredible intelligence of corvids with researchers who study these feathered geniuses. You'll never look at crows the same way again.",
  topic: "Science & Innovation",
  duration: "18:50",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Educational",
  topics: ["Animals", "Intelligence", "Nature"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1572402230267-f3e267c1e5a2?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/smart-crows.mp3"
},
{
  id: 283,
  title: "City Wildlife: The Secret Genius of Urban Animals",
  summary: "How raccoons are mastering complex locks while pigeons navigate skyscraper canyons. Discover the astonishing adaptations turning ordinary city animals into urban survival experts. The hidden intelligence revolution happening right outside your window.",
  topic: "Science & Innovation",
  duration: "17:15",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Urban Wildlife", "Animal Intelligence", "Adaptation", "City Ecology"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/city-wildlife-secret-genius.mp3"
},
{
  id: 284,
  title: "The Lost Symphony of Obsolete Technology",
  summary: "Why does the dial-up modem scream feel nostalgic? Decoding the hidden psychology behind extinct tech sounds—from mechanical keyboard clicks to VCR whirs. Discover how these auditory fossils trigger deep memory pathways and emotional responses.",
  topic: "Technology & AI",
  duration: "14:35",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "plus",
  episodeType: "Critique",
  topics: ["Tech Nostalgia", "Sound Psychology", "Memory Triggers", "Digital Archaeology"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/lost-symphony-obsolete-tech.mp3"
},
{
  id: 285,
  title: "Web 1.0: The Digital Wild West We Lost",
  summary: "What happened to the weird, wonderful chaos of the early internet? Exploring the untamed digital frontier of Geocities pages, AIM away messages, and dial-up rituals. Was the internet more magical when it was slower, stranger, and built by amateurs?",
  topic: "History & Culture",
  duration: "19:10",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Internet History", "Digital Nostalgia", "Web Archaeology", "Lost Digital Culture"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/web-1-0-digital-wild-west.mp3"
},
{
  id: 286,
  title: "The Science of Holiday Lights: From Incandescent to RGB Smart Bulbs",
  summary: "A festive deep dive into lighting technology! We explore why Christmas lights tangle so easily (physics!), the evolution from dangerous candle flames to app-controlled LEDs, and how to create the most satisfying holiday light display according to science.",
  topic: "Science & Innovation",
  duration: "15:50",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Educational",
  topics: ["Holidays", "Physics", "Technology"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1512389098783-66b81f86e199?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/holiday-light-science.mp3"
},
{
  id: 287,
  title: "The Science of the Perfect Playlist",
  summary: "What's the secret algorithm behind music that moves us? Decoding the neuroscience of tempo progression, key changes, and emotional sequencing. Discover why certain song orders feel like magic and how to engineer soundtracks for any mood or moment.",
  topic: "Creative Arts",
  duration: "16:40",
  publishDate: "Coming soon",
  relatedCourseId: 107,
  tier: "free",
  episodeType: "Tutorial",
  topics: ["Music Psychology", "Neuroscience of Sound", "Playlist Engineering", "Emotional Sequencing"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/science-perfect-playlist.mp3"
},
{
  id: 288,
  title: "Digital Afterlives: The Ethics of AI-Generated Memory",
  summary: "What happens when we use AI to recreate lost voices? Examining psychology studies on grief, ethical frameworks for digital legacy, and technical analysis of voice synthesis tools. The complex intersection of technology, memory, and human connection.",
  topic: "Personal Development",
  duration: "21:30",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["AI Ethics", "Digital Legacy", "Grief Technology", "Memory Science"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop",
  audioUrl: "/audio/digital-afterlives-ethics.mp3"
},
{
  id: 289,
  title: "Ambient Intimacy: The New Social Calculus",
  summary: "Why do we share everything with strangers but avoid texting friends back? Analyzing communication pattern data, social network studies, and generational research on digital connection. The mathematical models behind our paradoxical sharing behaviors.",
  topic: "Personal Development",
  duration: "18:45",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "plus",
  episodeType: "Educational",
  topics: ["Social Algorithms", "Digital Intimacy", "Communication Patterns", "Network Theory"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
  audioUrl: "/audio/ambient-intimacy-calculus.mp3"
},
{
  id: 290,
  title: "The Internet's Invisible Architecture",
  summary: "Who keeps the digital world from collapsing? We trace the physical infrastructure—undersea cables, data center cooling systems, battery farms—that makes streaming, scrolling, and searching possible. The hidden engineering marvels nobody talks about.",
  topic: "Technology & AI",
  duration: "24:20",
  publishDate: "Coming soon",
  relatedCourseId: 103,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Infrastructure", "Internet Architecture", "Engineering", "Digital Foundation"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=250&fit=crop",
  audioUrl: "/audio/internet-invisible-architecture.mp3"
},
{
  id: 291,
  title: "Decision Paralysis in the Age of Everything-On-Demand",
  summary: "Why does choosing a Netflix show feel harder than choosing a career path 50 years ago? We explore the neuroscience of choice overload in streaming, food delivery apps, dating apps, and even AI art generators. With solutions for reducing modern decision fatigue.",
  topic: "Health & Wellness",
  duration: "17:15",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Educational",
  topics: ["Decision Making", "Psychology", "Modern Life", "Neuroscience"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/decision-paralysis.mp3"
},
{
  id: 292,
  title: "The Convenience Paradox: How Time-Saving Tech Made Us More Impatient",
  summary: "Same-day delivery, instant streaming, 15-second TikTok—we examine how our tolerance for waiting has evaporated. Interviews with elders who remember weeks-long shipping, and psychologists studying how instant gratification rewires our brains for everyday frustrations.",
  topic: "Personal Development",
  duration: "19:40",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "plus",
  episodeType: "Debate",
  topics: ["Technology", "Psychology", "Patience", "Modern Life"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/convenience-paradox.mp3"
},
{
  id: 293,
  title: "Digital Childhood: The Science of Screen Time",
  summary: "What does research actually say about kids and screens? We analyze longitudinal studies, developmental psychology data, and educational technology efficacy reports. Evidence-based guidelines for raising tech-literate children without the panic.",
  topic: "Personal Development",
  duration: "22:10",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Child Development", "Screen Time Research", "Tech Literacy", "Parenting Science"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1544717305-99670f9c28f5?w=400&h=250&fit=crop",
  audioUrl: "/audio/digital-childhood-science.mp3"
},
{
  id: 294,
  title: "Boredom as a Superpower: Why We Can't Sit with Our Thoughts Anymore",
  summary: "In a world of infinite distraction, we've lost the ability to be bored—and creativity might be suffering. We explore studies linking boredom to innovation, interview artists who schedule 'boredom time,' and try a week-long 'boredom challenge' with surprising results.",
  topic: "Creative Arts",
  duration: "20:25",
  publishDate: "Coming soon",
  relatedCourseId: 106,
  tier: "free",
  episodeType: "Tutorial",
  topics: ["Creativity", "Boredom", "Productivity", "Mindfulness"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/art-of-boredom.mp3"
},
{
  id: 295,
  title: "Digital Etiquette in the Age of Awkward: Unwritten Rules of Modern Communication",
  summary: "How long should a voice message be? Is reacting with 😂 to bad news okay? Should you send an email after 8pm? We crowdsource the most confusing modern etiquette dilemmas and consult etiquette experts (yes, they exist for digital too!) for definitive answers.",
  topic: "Personal Development",
  duration: "16:50",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Educational",
  topics: ["Etiquette", "Communication", "Social Norms", "Digital Life"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1517077304055-6e89abbf09b0?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-etiquette.mp3"
},
{
  id: 296,
  title: "Simulation Regret: When You Can 'Try' Every Life Path",
  summary: "What happens to 'the road not taken' when AI can simulate alternative life choices? We explore people using AI to simulate different career paths, relationships, and life decisions—and whether seeing 'what could have been' leads to more or less regret.",
  topic: "Technology & AI",
  duration: "23:15",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["AI Ethics", "Psychology", "Regret", "Simulation"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/simulation-regret.mp3"
},
{
  id: 297,
  title: "Externalized Memory: When Your Phone Remembers More Than You Do",
  summary: "We outsource memories to photos we never look at, notes we never read, and cloud storage. What happens to human memory when we don't exercise it? Interviews with memory champions, neuroscientists, and people doing 'digital memory detoxes.'",
  topic: "Health & Wellness",
  duration: "19:30",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "plus",
  episodeType: "Educational",
  topics: ["Memory", "Neuroscience", "Technology", "Psychology"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/externalized-memory.mp3"
},
{
  id: 298,
  title: "The Slow Media Movement: Newsletters, Podcasts, and 'Anti-Viral' Content",
  summary: "While everyone chases 6-second virality, a counter-movement embraces depth, nuance, and patience. We profile creators building audiences with long-form, slow-burn content and examine whether attention spans are bifurcating into 'TikTok brain' and 'deep focus brain.'",
  topic: "Creative Arts",
  duration: "21:45",
  publishDate: "Coming soon",
  relatedCourseId: 105,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Media", "Attention", "Content Creation", "Slow Movement"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1581276879432-15e50529f34b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/slow-media-movement.mp3"
},
{
  id: 299,
  title: "Digital Sabbath Diaries: What Happens When Tech Leaders Unplug",
  summary: "Silicon Valley executives, social media managers, and game developers trying 24-72 hour tech detoxes. The surprising productivity insights, emotional revelations, and whether any of them actually stick with it. Plus: listener-submitted digital detox stories.",
  topic: "Health & Wellness",
  duration: "18:20",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Educational",
  topics: ["Digital Detox", "Mental Health", "Productivity", "Experiments"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-sabbath.mp3"
},
{
  id: 300,
  title: "When Your Teacher Is an AI: The Future (and Limits) of Personalized Education",
  summary: "AI tutors that adapt to your learning style in real-time vs. human teachers who notice when you're having a bad day. We test the best AI learning tools, interview educators integrating AI, and ask: what can only humans teach humans?",
  topic: "Technology & AI",
  duration: "22:40",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["Education", "AI Tutors", "Learning", "Future of Work"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/ai-tutors.mp3"
},
{
  id: 301,
  title: "The Curiosity Economy: How Random Learning Became Valuable",
  summary: "Why knowing a little about everything is suddenly a career asset. We explore how interdisciplinary thinkers connect dots in innovation, interview 'professional generalists,' and discuss whether hyper-specialization is becoming obsolete in an AI world.",
  topic: "Personal Development",
  duration: "20:15",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "plus",
  episodeType: "Educational",
  topics: ["Learning", "Curiosity", "Career", "Interdisciplinary"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1456513080510-3449c76e8c4c?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/curiosity-economy.mp3"
},
{
  id: 302,
  title: "Your Invisible Score: How Algorithms Judge Your Worth Beyond Credit",
  summary: "Beyond credit scores, there are hundreds of hidden algorithms scoring you: delivery driver ratings, tenant screening scores, social media 'engagement worthiness,' even dating app desirability scores. We investigate these opaque systems and interview data scientists who've built them.",
  topic: "Technology & AI",
  duration: "25:10",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "pro",
  episodeType: "Investigation",
  topics: ["Algorithms", "Privacy", "Data", "Social Systems"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/invisible-scores.mp3"
},
{
  id: 303,
  title: "Smart Home Data Analysis: What Your Devices Reveal",
  summary: "Your smart home knows more than you think. Analyzing anonymized device usage patterns, energy consumption data, and behavioral correlation studies. The surprising insights extractable from everyday IoT data trails.",
  topic: "Technology & AI",
  duration: "19:45",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Smart Home Data", "IoT Analytics", "Behavioral Patterns", "Digital Footprints"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=250&fit=crop",
  audioUrl: "/audio/smart-home-data-analysis.mp3"
},
{
  id: 304,
  title: "Digital Hoarding: When Your Cloud Storage Becomes a Psychological Burden",
  summary: "40,000 unread emails, 8TB of photos never organized, thousands of abandoned files. Digital hoarding has real psychological costs. We explore the neuroscience of digital attachment, interview 'digital organizers,' and follow someone through a massive digital cleanup.",
  topic: "Personal Development",
  duration: "21:30",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Educational",
  topics: ["Digital Organization", "Psychology", "Hoarding", "Mental Health"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-hoarding.mp3"
},
{
  id: 305,
  title: "Digital Inheritance: The New Estate Planning Algorithm",
  summary: "Who inherits your digital life? Analyzing legal frameworks, platform policies, and cryptographic solutions for posthumous digital asset management. The emerging field of digital estate architecture and its complex challenges.",
  topic: "Personal Development",
  duration: "23:15",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Digital Inheritance", "Estate Planning", "Digital Assets", "Posthumous Data"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop",
  audioUrl: "/audio/digital-inheritance-algorithm.mp3"
},
{
  id: 306,
  title: "Streaming's Dirty Secret: The Physical Footprint of Digital Content",
  summary: "Every Netflix binge, Spotify playlist, and cloud backup has a real-world environmental cost. We visit data centers, interview sustainability experts in tech, and calculate the carbon footprint of common digital activities. Surprising findings about which digital habits are most costly.",
  topic: "Science & Innovation",
  duration: "24:40",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Investigation",
  topics: ["Environment", "Technology", "Sustainability", "Streaming"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1569163139394-de44cb2c8cb7?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/streaming-footprint.mp3"
},
{
  id: 307,
  title: "Zoom Spine & Keyboard Hunch: The New Physical Maladies of Digital Life",
  summary: "Chronic pain patterns from constant video calls, 'text neck,' RSI from endless typing. We interview physical therapists specializing in tech-related injuries, ergonomic designers, and remote workers who've transformed their physical health while working digitally.",
  topic: "Health & Wellness",
  duration: "18:25",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "free",
  episodeType: "Tutorial",
  topics: ["Health", "Remote Work", "Ergonomics", "Physical Therapy"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-physical-toll.mp3"
},
{
  id: 308,
  title: "Parasocial Commerce: When Strangers Feel Like Friends Who Sell You Things",
  summary: "How influencers, podcasters, and creators monetize simulated intimacy. We explore the psychology behind feeling like you 'know' internet personalities, interview creators about their boundaries, and examine when these relationships cross into manipulation.",
  topic: "Business & Entrepreneurship",
  duration: "22:50",
  publishDate: "Coming soon",
  relatedCourseId: 105,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Influencers", "Psychology", "Marketing", "Relationships"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/parasocial-commerce.mp3"
},
{
  id: 309,
  title: "Keyboard Warriors & Fandom Armies: The New Digital Tribalism",
  summary: "How niche interests become identities with their own languages, hierarchies, and conflicts. From Swifties to crypto bros to gaming clans, we explore how digital tribes form, fight, and create meaning in an increasingly fragmented online world.",
  topic: "History & Culture",
  duration: "20:15",
  publishDate: "Coming soon",
  relatedCourseId: null,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Online Communities", "Identity", "Culture", "Social Dynamics"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-tribalism.mp3"
},
{
  id: 310,
  title: "AI Relationship Science: Can Algorithms Counsel Couples?",
  summary: "What happens when ChatGPT gives marriage advice? We test relationship counseling AIs against established therapeutic frameworks, analyzing response patterns, bias detection, and ethical boundaries. The surprising accuracy—and alarming gaps—in AI relationship guidance.",
  topic: "Technology & AI",
  duration: "26:20",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "pro",
  episodeType: "Investigation",
  topics: ["AI Counseling", "Relationship Science", "Therapeutic AI", "Ethical Algorithms"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop",
  audioUrl: "/audio/ai-relationship-science.mp3"
},
{
  id: 311,
  title: "Digital Third Places: Bars, Cafes, and Parks of the Internet",
  summary: "How Discord servers, Slack communities, and multiplayer game lobbies are replacing physical 'third places' for connection. We explore what makes a digital space feel like 'home,' interview community builders, and examine the loneliness crisis these spaces address.",
  topic: "Personal Development",
  duration: "19:10",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Community", "Loneliness", "Digital Spaces", "Connection"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-third-places.mp3"
},
{
  id: 312,
  title: "Algorithmic Synchronicity: When Tech Feels Like Magic or Mind-Reading",
  summary: "That eerie moment when an ad appears for something you just thought about. We explore confirmation bias, data collection depth, and the psychology behind perceiving algorithms as 'magical.' Interviews with data scientists and psychologists studying this phenomenon.",
  topic: "Technology & AI",
  duration: "17:45",
  publishDate: "Coming soon",
  relatedCourseId: 101,
  tier: "plus",
  episodeType: "Educational",
  topics: ["Algorithms", "Psychology", "Privacy", "Synchronicity"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/algorithmic-synchronicity.mp3"
},
{
  id: 313,
  title: "Which 'You' Is Real? The Multiple Identities Problem",
  summary: "Work you, social media you, dating app you, anonymous forum you. We explore philosophical questions about identity in a world where we curate different selves for different platforms. With philosophers, psychologists, and people who feel fragmented by their digital personas.",
  topic: "Personal Development",
  duration: "23:50",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "pro",
  episodeType: "Deep Dive",
  topics: ["Identity", "Philosophy", "Psychology", "Digital Self"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1456513080510-3449c76e8c4c?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-identity-philosophy.mp3"
},
{
  id: 314,
  title: "Attention Arbitrage: How Your Focus Is Bought and Sold Multiple Times",
  summary: "Following a single moment of your attention from initial capture (social media) through data brokers, ad exchanges, and retargeting networks. We map the invisible economy trading your focus, and interview people trying to 'take back' their attention.",
  topic: "Business & Entrepreneurship",
  duration: "25:30",
  publishDate: "Coming soon",
  relatedCourseId: 105,
  tier: "pro",
  episodeType: "Investigation",
  topics: ["Attention Economy", "Advertising", "Data", "Privacy"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/attention-arbitrage.mp3"
},
{
  id: 315,
  title: "Digital Serfs: When Algorithmic Bosses Never Sleep",
  summary: "Gig workers, content moderators, and micro-taskers living under 24/7 algorithmic management. We interview workers across platforms about unpredictable algorithms, opaque rating systems, and the psychological toll of being managed by code.",
  topic: "Business & Entrepreneurship",
  duration: "24:15",
  publishDate: "Coming soon",
  relatedCourseId: 104,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Gig Economy", "Labor", "Algorithms", "Workplace"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1551836026-d5c8e2c2e99c?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-serfdom.mp3"
},
{
  id: 316,
  title: "Digital Darwinism: How Our Bodies Are Changing for Screen Life",
  summary: "Myopia epidemic from indoor living, changing posture from device use, even potential evolutionary shifts. We interview anthropologists, ophthalmologists, and ergonomic researchers about how digital life is physically reshaping humans in real-time.",
  topic: "Health & Wellness",
  duration: "21:20",
  publishDate: "Coming soon",
  relatedCourseId: 110,
  tier: "plus",
  episodeType: "Deep Dive",
  topics: ["Evolution", "Health", "Technology", "Biology"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/digital-darwinism.mp3"
},
{
  id: 317,
  title: "What Lives on Your Phone? The Digital Microbiome",
  summary: "Your smartphone carries more bacteria than a toilet seat, but also a unique fingerprint of your life: skin cells, food particles, environmental exposures. We swab devices, analyze results with microbiologists, and explore what our device microbiomes reveal about us.",
  topic: "Science & Innovation",
  duration: "18:35",
  publishDate: "Coming soon",
  relatedCourseId: 109,
  tier: "free",
  episodeType: "Educational",
  topics: ["Microbiology", "Health", "Technology", "Science"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/device-microbiome.mp3"
},
{
  id: 318,
  title: "The Podcast About Podcasts About Digital Life",
  summary: "A meta-conversation about why we're obsessed with analyzing our digital existence. We examine the irony of using digital platforms to discuss digital detox, interview podcasters in this space, and ask: is this content helpful or just adding to the noise?",
  topic: "Personal Development",
  duration: "22:45",
  publishDate: "Coming soon",
  relatedCourseId: 108,
  tier: "free",
  episodeType: "Critique",
  topics: ["Meta", "Podcasting", "Digital Life", "Criticism"],
  listens: 0,
  isDownloadable: false,
  image: "https://images.unsplash.com/photo-1581276879432-15e50529f34b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/meta-podcast.mp3"
},
{
  id: 319,
  title: "Phone Call Anxiety: Why We'd Rather Text Anything",
  summary: "When did talking become terrifying? Unpacking the psychology behind our collective dread of phone calls. Discover why digital natives freeze at ringtones and how our brains have rewired for text-based communication in just one generation.",
  topic: "Personal Development",
  duration: "16:20",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Communication Anxiety", "Digital Psychology", "Social Evolution", "Phone Phobia"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1546007188-cc0eac9b09d3?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/phone-call-anxiety-psychology.mp3"
},
{
  id: 320,
  title: "Group Text Dynamics: The Social Physics of Digital Tribes",
  summary: "Why do some group chats thrive for years while others die instantly? Analyzing chat data patterns, participation metrics, and social network theory to decode the algorithms of successful digital communities. The mathematical principles behind digital tribe formation.",
  topic: "Personal Development",
  duration: "14:45",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Social Dynamics", "Digital Communities", "Group Psychology", "Communication Patterns"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=250&fit=crop",
  audioUrl: "/audio/group-text-dynamics.mp3"
},
{
  id: 321,
  title: "The Algorithm Behind Your Netflix Recommendations",
  summary: "Breaking down how streaming services predict what you'll want to watch next. We explore viewing pattern analysis, similarity algorithms, and why you keep getting recommended the same types of shows.",
  topic: "Technology & AI",
  duration: "16:45",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Algorithms", "Streaming", "Recommendations"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/netflix-algorithm.mp3"
},
{
  id: 322,
  title: "The Explosive Physics of Popping Popcorn",
  summary: "What violent magic turns hard kernels into fluffy clouds? We reveal the explosive science inside every popcorn piece—moisture turning to steam, starches expanding like microscopic balloons, and the precise pressure point where magic happens. Why some kernels stubbornly refuse to pop.",
  topic: "Science & Innovation",
  duration: "13:40",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Food Physics", "Explosive Science", "Kitchen Chemistry", "Popcorn Magic"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1623258727990-0ee8bae749a7?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/explosive-physics-popcorn.mp3"
},
{
  id: 323,
  title: "Why ASMR Works: The Brain Science Behind Internet Whispering",
  summary: "Exploring why millions find whispering, tapping, and crinkling sounds so relaxing. We dive into autonomous sensory meridian response research, brain scan studies, and why this internet phenomenon triggers actual physiological responses.",
  topic: "Science & Innovation",
  duration: "17:20",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["ASMR", "Neuroscience", "Internet Culture"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/asmr-science.mp3"
},
{
  id: 324,
  title: "The Lost Art of Boredom: Why Your Brain Needs Downtime",
  summary: "In a world of infinite distraction, we're losing the creative benefits of boredom. Examining studies linking daydreaming to innovation, and why constant stimulation might be making us less creative.",
  topic: "Personal Development",
  duration: "16:45",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Psychology", "Creativity", "Mindfulness"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/art-of-boredom.mp3"
},
{
  id: 325,
  title: "Why Horror Movies Make Us Feel Good",
  summary: "The paradox of enjoying being scared. Exploring the psychology and neuroscience behind why people seek out frightening experiences, from horror films to haunted houses, and how controlled fear can be therapeutic.",
  topic: "Creative Arts",
  duration: "17:30",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Psychology", "Horror", "Neuroscience"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1489599809505-fc6acc43c69f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/horror-psychology.mp3"
},
{
  id: 326,
  title: "Why We're All Developing 'Menu Anxiety'",
  summary: "The paralysis of choice in the age of endless options. From 50-page restaurant menus to infinite streaming catalogs, examining why more choices often lead to less satisfaction and higher anxiety.",
  topic: "Personal Development",
  duration: "16:25",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Psychology", "Decision Making", "Modern Life"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/menu-anxiety.mp3"
},
{
  id: 327,
  title: "The 'Uncanny Valley' of AI Voices",
  summary: "Why some AI voices feel comforting while others creep us out. Exploring the audio equivalent of the uncanny valley - the narrow band where synthetic voices become too human-like, triggering unease instead of trust.",
  topic: "Technology & AI",
  duration: "16:40",
  publishDate: "Coming soon",
  tier: "plus",
  episodeType: "Educational",
  topics: ["AI Voices", "Psychology", "Uncanny Valley"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/ai-voice-uncanny-valley.mp3"
},
{
  id: 328,
  title: "Why We Can't Resist Clicking 'Watch Next'",
  summary: "The autoplay trap: How streaming platforms engineer compulsive viewing. Examining the psychology of cliffhangers, algorithmically curated sequences, and why 'just one more episode' is rarely just one.",
  topic: "Personal Development",
  duration: "17:25",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Psychology", "Streaming", "Addiction"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/autoplay-trap.mp3"
},
{
  id: 329,
  title: "The Rise of 'Cozy Games' and Comfort Gaming",
  summary: "Why games like Stardew Valley and Animal Crossing became therapy tools. Exploring how low-stakes, repetitive, nurturing gameplay provides psychological relief in high-anxiety times.",
  topic: "Creative Arts",
  duration: "19:30",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Deep Dive",
  topics: ["Gaming", "Mental Health", "Comfort"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/cozy-games-therapy.mp3"
},
{
  id: 330,
  title: "Why We Photograph Food (And What It Does to Our Brains)",
  summary: "The neuroscience behind #foodporn culture. How photographing meals affects memory, enjoyment, and social bonding - and why some restaurants now design dishes specifically for Instagram.",
  topic: "Creative Arts",
  duration: "16:55",
  publishDate: "Coming soon",
  tier: "free",
  episodeType: "Educational",
  topics: ["Food Photography", "Neuroscience", "Social Media"],
  listens: 0,
  image: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=400&h=250&fit=crop",
  audioUrl: "/audio/podcasts/food-photography-psychology.mp3"
},
];

export const trendingContent = [
  { id: 201, type: 'podcast' },
  { id: 202, type: 'podcast' },
  { id: 204, type: 'podcast' },
  { id: 216, type: 'podcast' },
  { id: 224, type: 'podcast' },
  { id: 101, type: 'course' },
  { id: 104, type: 'course' },
  { id: 103, type: 'course' }
]

export const announcements = [
  {
    id: 1,
    title: "New Ambassador Program Launched",
    content: "Apply now for our Ambassador Program and get free Saints Pro access while helping others learn.",
    date: "2024-01-15"
  },
  {
    id: 2,
    title: "Winter Learning Challenge",
    content: "Join our 30-day learning challenge starting next week. Complete courses and win exclusive rewards.",
    date: "2024-01-10"
  },
  {
    id: 3,
    title: "New Course Categories Added",
    content: "We've expanded our library with new courses in Health & Wellness and History & Culture categories.",
    date: "2024-01-05"
  }
]

// Export categories and tiers for the LearningHub and PodcastHub

export const courseTiers = ['All', 'Free', 'Plus', 'Pro']

export const podcastCategories = [
  'All', 'Technology & AI', 'Business & Entrepreneurship', 'Creative Arts', 
  'Personal Development', 'Science & Innovation', 'Health & Wellness', 
  'History & Culture', 'Skills & Hobbies'
]

export const podcastTiers = ['All', 'Free', 'Plus', 'Pro']

export const episodeTypes = ['All', 'Critique', 'Tutorial', 'Deep Dive', 'Debate', 'Educational', 'Investigation', 'Analysis', 'Documentary', 'Explainer']